import React from 'react';
import { DateInput } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const DateInputRhf = ({ ...props }: Props) => {
  return (
    <ComponentWrapperRHF {...props}>
      <DateInput />
    </ComponentWrapperRHF>
  );
};
